const axios = require('axios');
const AuthProvider = require('./provider');
const HttpRequest = require('./http-request');

/**
 * Client for EAS interaction, specifically fetching entity object.
 */
class EAS {
  /**
   * Create an object for accessing an Entity Attribute Service.
   * @param {object} config - options to  configure this EAS accessor
   * @param {AuthProvider|function} config.authProvider - interceptor for `http-request.Request` object manipulation
   * @param {string} config.endpoint - the URI to connect to
   * @param {function} [config.requestFunctor=axios.request] - http request async function object
   */
  constructor({ authProvider, endpoint, requestFunctor }) {
    if (authProvider instanceof AuthProvider) {
      this.authProvider = (r) => authProvider.injectAuth(r);
    } else {
      this.authProvider = authProvider;
    }
    this.endpoint = endpoint;
    this.requestFunctor = requestFunctor || axios.request;
  }

  /**
   * Request an entity object for the current user.
   * @param {object} config - options for the request
   * @param {string} config.publicKey - String encoded public key from the keypair to be used with any subsequent requests refering to the returned EO
   * @param {object} [config.etc] - additional parameters to be passed to the EAS entity-object endpoint
   */
  async fetchEntityObject({ publicKey, ...etc }) {
    // Create a skeleton http request for EAS.
    const httpReq = new HttpRequest();
    httpReq.headers['Content-Type'] = 'application/json';

    // Connect the same ref to each name so authProvider can manipulate either.
    httpReq.body = httpReq.params = { publicKey, ...etc };
    httpReq.url = this.endpoint;
    httpReq.method = 'post';

    // Delegate modifications to the auth provider.
    // TODO: Handle various exception cases from interface docs.
    await this.authProvider(httpReq);

    // Execute the http request using axios.
    const method = httpReq.method.toLowerCase();
    const axiosParams = {
      method,
      headers: httpReq.headers,
    };
    // Allow the authProvider to change the method.
    if (method === 'post' || method === 'patch' || method === 'put') {
      axiosParams.data = httpReq.body;
    } else {
      axiosParams.params = httpReq.body;
    }
    return (await this.requestFunctor(httpReq.url, axiosParams)).data;
  }
}

module.exports = EAS;
